import { __require as requirePostcss } from "../../../postcss@8.5.8/node_modules/postcss/lib/postcss2.js";
import { __require as requireParser } from "./parser.js";
import { __require as requireProcessResult } from "./process-result.js";
var sync;
var hasRequiredSync;
function requireSync() {
  if (hasRequiredSync) return sync;
  hasRequiredSync = 1;
  let postcss = requirePostcss();
  let parse = requireParser();
  let processResult = requireProcessResult();
  sync = function(plugins) {
    let processor = postcss(plugins);
    return (input) => {
      let result = processor.process(input, { parser: parse, from: void 0 });
      return processResult(result);
    };
  };
  return sync;
}
export {
  requireSync as __require
};
//# sourceMappingURL=sync.js.map
